import React from 'react'
import PropTypes from 'prop-types'
import idx from 'idx'
import { keyframes, withTheme, styled } from '../theming-sc'
import IconMapper from './iconMapper'

const spinKeyframes = keyframes`
  from {
    transform:rotate(0deg);
  }
  to {
    transform:rotate(360deg);
  }
`

const Icon = ({
  type,
  size,
  style,
  baseColor,
  accentColor,
  light,
  grey,
  colored,
  duotone,
  spin,
  theme,
  ...rest
}) => {
  const IconComponent =
    spin || (type === 'loading' && !spin)
      ? styled(IconMapper[type])`
          animation: ${spinKeyframes} 1s infinite linear;
        `
      : IconMapper[type]
  const defaultLightColor = '#fff'
  const defaultDarkColor = idx(theme, _ => _.palette.greyDark) || '#4d4d4d'
  const defaultGreyColor = idx(theme, _ => _.palette.greyLight) || '#afafaf'
  const defaultAccentColor = idx(theme, _ => _.palette.primary) || '#001eff'
  const primaryColor = baseColor || (grey && defaultGreyColor) || (light && defaultLightColor) || (colored && defaultAccentColor) || defaultDarkColor
  const secondaryColor = accentColor || (duotone && defaultAccentColor) || primaryColor

  const properties = {
    size: size,
    style: { ...style, width: size, height: size },
    primaryColor: primaryColor,
    secondaryColor: secondaryColor
  }

  const { innerRef, ...props } = rest

  return IconComponent ? <IconComponent {...props} {...properties} /> : null
}

Icon.propTypes = {
  type: PropTypes.string.isRequired,
  size: PropTypes.number,
  baseColor: PropTypes.string,
  accentColor: PropTypes.string,
  light: PropTypes.bool,
  grey: PropTypes.bool,
  colored: PropTypes.bool,
  duotone: PropTypes.bool,
  spin: PropTypes.bool
}

Icon.defaultProps = {
  size: 20,
  theme: {}
}

export default withTheme(Icon)
